import Button from '../Button'
import { parseFee } from '../../utils/parseFee'

// Coupon entry for paid event checkout. Self-gates: only renders when the event
// has the payment gateway on, coupons enabled, and a non-zero fee. State lives in
// the parent (EventDetail) so the applied code flows into create-order.
const CouponField = ({
  event,
  couponInput,
  onChange,
  onApply,
  couponChecking,
  couponError,
  appliedCoupon,
}) => {
  if (!event?.paymentGatewayEnabled || !event?.couponsEnabled || parseFee(event.fee) <= 0) {
    return null
  }

  return (
    <div className="rounded-xl border border-gray-200 p-3 space-y-2">
      <label className="block text-sm font-medium text-gray-700">Have a coupon?</label>
      <div className="flex gap-2">
        <input
          type="text"
          value={couponInput}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter code"
          className="flex-1 px-3 py-2 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 uppercase"
        />
        <Button
          type="button"
          variant="secondary"
          onClick={onApply}
          disabled={couponChecking || !couponInput.trim()}
        >
          {couponChecking ? 'Checking…' : 'Apply'}
        </Button>
      </div>
      {couponError && <p className="text-sm text-red-600">{couponError}</p>}
      {appliedCoupon && (
        <p className="text-sm text-green-700">
          {appliedCoupon.discountPercent}% off applied — you pay ₹{(appliedCoupon.discountedFee / 100).toFixed(2)}
        </p>
      )}
    </div>
  )
}

export default CouponField
